import { useTranslation } from 'react-i18next';

export const infoByAFMRefs = () => {
  const { t } = useTranslation();
  
  return [
    { refValue: 'afm', title: t(' Αριθμός Φορολογικού Μητρώου Α.Φ.Μ. ') },
    { refValue: 'doy', title: t('Περιφερειακή Ενότητα') },
    { refValue: 'doyDescr', title: t(' Περιγραφή Δ.Ο.Υ') },
    { refValue: 'iNiFlag', title: t(' Φυσικό ή Μη Φυσικό Πρόσωπο (λαμβάνει τις τιμές 1 = Φυσικό Πρόσωπο, 2 = Μη Φυσικό Πρόσωπο) ') },
    { refValue: 'deactivationFlag', title: t(' Ένδειξη Απενεργοποίησης Α.Φ.Μ. (λαμβάνει τις τιμές 1 = Ενεργό, 2 = Απενεργοποιημένο) ') },
    { refValue: 'assTxpActual', title: t(' ΑΦΜ ΠΟΥ ΔΙΑΤΗΡΕΙΤΑΙ (ΓΙΑ ΑΠΕΝΕΡΓΟΠΟΙΗΜΕΝΟ ΑΦΜ)') },
    { refValue: 'onomasia', title: t(' Επωνυμία ή Επώνυμο, Β’ Επώνυμο, Όνομα, Πατρώνυμο ') },
    { refValue: 'mothersFirstName', title: t(' Μητρώνυμο') },
    { refValue: 'birthDate', title: t(' Ημερομηνία Γέννησης') },
    { refValue: 'birthPlace', title: t(' Τόπος Γέννησης') },
    { refValue: 'cntResidenceDescr', title: t(' Χώρα Κατοικίας') },
    { refValue: 'residenceAddress', title: t(' Οδός κατοικίας') },
    { refValue: 'residenceAddressNo', title: t(' Αριθμός κατοικίας') },
    { refValue: 'residenceZipCode', title: t(' Ταχυδρομικός Κώδικας κατοικίας') },
    { refValue: 'residenceParDescr', title: t(' Περιοχή κατοικίας') },
    { refValue: 'firmCommerTitle', title: t(' Τίτλος Επιχείρησης') },
    { refValue: 'firmDoy', title: t(' Δ.Ο.Υ Επιχείρησης') },
    { refValue: 'firmAddress', title: t(' Οδός Επιχείρησης ') },
    { refValue: 'firmAddressNo', title: t(' Αριθμός Επιχείρησης') },
    { refValue: 'firmZipCode', title: t(' Ταχυδρομικός Κώδικας Επιχείρησης') },
    { refValue: 'firmParDescr', title: t(' Περιοχή Επιχείρησης') },
    { refValue: 'firmFax', title: t('Φαξ Επιχείρησης') },
  ];
};

export const infoByADTRefs = [
  {refValue: 'cardNo', title: 'Αριθμός Δελτίου Ταυτότητας'},
  {refValue: 'cardKindDescr', title: 'Περιγραφή Είδους Ταυτότητας'},
  {refValue: 'cardAuthDescr', title: 'Περιγραφή Αρχής Έκδοσης Ταυτότητας'},
  {refValue: 'cardDate', title: 'Ημερομηνία Έκδοσης Ταυτότητας'},
  {refValue: 'afm', title: 'Aριθμός Φορολογικού Μητρώου Α.Φ.Μ'},
  {refValue: 'deactFlag', title: 'Ένδειξη Απενεργοποίησης Α.Φ.Μ. (1: Ενεργό , 2: Απενεργοποιημένο)'},
  {refValue: 'assTxpActual', title: 'Ενεργό ΑΦΜ στην Περίπτωση του Απενεργοποιημένου '},
  {refValue: 'firmFlag', title: 'Ένδειξη Επιτηδευματία (1 = Επιτηδευματίας, 2 = Μη Επιτηδευματίας, 3 = Πρώην Επιτηδευματίας)'},
  {refValue: 'cntCitizenshipDescr', title: 'Υπηκοότητα '},
  {refValue: 'birthDate', title: 'Ημερομηνία Γέννησης'},
  {refValue: 'birthPlace', title: 'Τόπος Γέννησης'},
  {refValue: 'deathDate', title: 'Ημερομηνία Θανάτου'},
  {refValue: 'doy', title: 'Δ.Ο.Υ '},
  {refValue: 'doyDescr', title: 'Περιγραφή Δ.Ο.Υ.'},
  {refValue: 'surname', title: 'Επώνυμο '},
  {refValue: 'secondSurname', title: 'Επώνυμο 2ο'},
  {refValue: 'firstName', title: 'Όνομα '},
  {refValue: 'fathersFirstName', title: 'Πατρώνυμο '},
  {refValue: 'fathersSurname', title: 'Επώνυμο Πατέρα '},
  {refValue: 'mothersFirstName', title: 'Όνομα Μητέρας'},
  {refValue: 'mothersSurname', title: 'Επώνυμο Μητέρας '},
  {refValue: 'cntResidenceDescr', title: 'Χώρα κατοικίας'},
  {refValue: 'residenceAddress', title: 'Οδός Κατοικίας '},
  {refValue: 'residenceNo', title: 'Αριθμός Οδού Κατοικίας'},
  {refValue: 'parResidence', title: 'Ταχυδρομικός Κώδικας Κατοικίας '},
  {refValue: 'parResidenceDescr', title: 'Περιοχή Κατοικίας '},
  {refValue: 'postalAddress', title: 'Οδός Φορολογικής Διεύθυνσης'},
  {refValue: 'postalNo', title: 'Αριθμός Φορολογικής Διεύθυνσης'},
  {refValue: 'parPostal', title: 'Ταχυδρομικός Κώδικας Φορολογικής Διεύθυνσης'},
  {refValue: 'parPostalDescr', title: 'Περιοχή Φορολογικής Διεύθυνσης'},
];

export const infoByAMKARefs = [
  {refValue: 'amkaCurrent', title: 'Ισχύων ΑΜΚΑ'},
  {refValue: 'lastDataLogDate', title: 'Ημερομηνία πιο πρόσφατης καταχώρησης των στοιχείων '},
  {refValue: 'adtType', title: 'Κωδικός είδους ταυτότητας '},
  {refValue: 'adt', title: 'Αριθμός ταυτότητας'},
  {refValue: 'yearOfAdtPublished', title: 'Έτος έκδοσης ταυτότητας'},
  {refValue: 'nationalityCountry', title: 'Χώρα υπηκοότητας'},
  {refValue: 'nationalityCountryCode', title: 'Κωδικός χώρας υπηκοότητας'},
  {refValue: 'sex', title: 'Κωδικός φύλου'},
  {refValue: 'afm', title: 'ΑΦΜ'},
  {refValue: 'birthSurnameEl', title: 'Επώνυμο κατά τη γέννηση (Ελληνικά)'},
  {refValue: 'idSurnameEl', title: 'Επώνυμο τρέχον (ταυτότητας) (Ελληνικά)'},
  {refValue: 'firstNameEl', title: 'Όνομα (Ελληνικά)'},
  {refValue: 'fatherNameEl', title: 'Πατρώνυμο (Ελληνικά)'},
  {refValue: 'motherNameEl', title: 'Μητρώνυμο (Ελληνικά)'},
  {refValue: 'birthSurnameEn', title: 'Επώνυμο κατά τη γέννηση (Λατινικά)'},
  {refValue: 'idSurnameEn', title: 'Επώνυμο τρέχον (ταυτότητας) (Λατινικά)'},
  {refValue: 'firstNameEn', title: 'Όνομα (Λατινικά)'},
  {refValue: 'fatherNameEn', title: 'Πατρώνυμο (Λατινικά)'},
  {refValue: 'motherNameEn', title: 'Μητρώνυμο (Λατινικά)'},
  {refValue: 'birthDate', title: 'Ημερομηνία γέννησης'},
  {refValue: 'fictitiousBirthDateIndication', title: 'Ένδειξη πλασματικής ημ/νίας γέννησης, Π = πλασματική'},
  {refValue: 'birthCountry', title: 'Χώρα γέννησης'},
  {refValue: 'birthCountryCode', title: 'Κωδικός χώρας γέννησης'},
  {refValue: 'birthMunicipality', title: 'Δήμος γέννησης'},
  {refValue: 'birthCountyCode', title: 'Κωδικός Ελληνικού νομού γέννησης (τα 4 πρώτα γράμματα του νομού)'},
  {refValue: 'addressStreetNum', title: 'Διεύθυνση: οδός - αριθμός'},
  {refValue: 'addressCity', title: 'Διεύθυνση: δήμος ή πόλη'},
  {refValue: 'addressCountyCode', title: 'Διεύθυνση: κωδικός νομού (τα 4 πρώτα γράμματα του νομού)'},
  {refValue: 'addressPostalCode', title: 'Διεύθυνση: Ταχυδρομικός Κώδικας'},
  {refValue: 'addressCountry', title: 'Χώρα διεύθυνσης'},
  {refValue: 'addressCountryCode', title: 'Κωδικός χώρας διεύθυνσης'},
  {refValue: 'phone1', title: 'Τηλέφωνο 1'},
  {refValue: 'phone2', title: 'Τηλέφωνο 2'},
  {refValue: 'deathIndication', title: 'Ένδειξη θανάτου (Θ = έχει αναγγελθεί θάνατος, Λ = έχει αναγγελθεί θάνατος με Ληξιαρχική πράξη)'},
  {refValue: 'deathDate', title: 'Ημερομηνία Θανάτου'},
];

export const paaypaByAMKARefs = [
  {refValue: 'status', title: 'Ένδειξη ΠΑΑΥΠΑ (Προσωρινός Αριθμός Ασφάλισης και Υγειονομικής Περίθαλψης Αλλοδαπού)'},
  {refValue: 'amkaCurrent', title: 'Ισχύων ΑΜΚΑ'},
  {refValue: 'lastDataLogDate', title: 'Ημερομηνία πιο πρόσφατης καταχώρησης των στοιχείων'},
  {refValue: 'adtType', title: 'Κωδικός είδους ταυτότητας '},
  {refValue: 'adt', title: 'Αριθμός ταυτότητας'},
  {refValue: 'yearOfAdtPublished', title: 'Έτος έκδοσης ταυτότητας'},
  {refValue: 'nationalityCountry', title: 'Χώρα υπηκοότητας'},
  {refValue: 'nationalityCountryCode', title: 'Κωδικός χώρας υπηκοότητας'},
  {refValue: 'sex', title: 'Κωδικός φύλου (ΑΡΡΕΝ ή ΘΗΛΥ)'},
  {refValue: 'afm', title: 'ΑΦΜ'},
  {refValue: 'birthSurnameEl', title: 'Επώνυμο κατά τη γέννηση (Ελληνικά)'},
  {refValue: 'idSurnameEl', title: 'Επώνυμο τρέχον (ταυτότητας) (Ελληνικά)'},
  {refValue: 'firstNameEl', title: 'Όνομα (Ελληνικά)'},
  {refValue: 'fatherNameEl', title: 'Πατρώνυμο (Ελληνικά)'},
  {refValue: 'motherNameEl', title: 'Μητρώνυμο (Ελληνικά)'},
  {refValue: 'birthSurnameEn', title: 'Επώνυμο κατά τη γέννηση (Λατινικά)'},
  {refValue: 'idSurnameEn', title: 'Επώνυμο τρέχον (ταυτότητας) (Λατινικά)'},
  {refValue: 'firstNameEn', title: 'Όνομα (Λατινικά)'},
  {refValue: 'fatherNameEn', title: 'Πατρώνυμο (Λατινικά)'},
  {refValue: 'motherNameEn', title: 'Μητρώνυμο (Λατινικά)'},
  {refValue: 'birthDate', title: 'Ημερομηνία γέννησης'},
  {refValue: 'fictitiousBirthDateIndication', title: 'Ένδειξη πλασματικής ημ/νίας γέννησης, Π = πλασματική'},
  {refValue: 'birthCountry', title: 'Χώρα γέννησης'},
  {refValue: 'birthCountryCode', title: 'Κωδικός χώρας γέννησης'},
  {refValue: 'birthMunicipality', title: 'Δήμος γέννησης'},
  {refValue: 'birthCountyCode', title: 'Κωδικός Ελληνικού νομού γέννησης (είναι τα 4 πρώτα γράμματα του νομού)'},
  {refValue: 'addressStreetNum', title: 'Διεύθυνση: οδός - αριθμός'},
  {refValue: 'addressCity', title: 'Διεύθυνση: δήμος ή πόλη'},
  {refValue: 'addressCountyCode', title: 'Διεύθυνση: κωδικός νομού (είναι τα 4 πρώτα γράμματα του νομού)'},
  {refValue: 'addressPostalCode', title: 'Διεύθυνση: Ταχυδρομικός Κώδικας'},
  {refValue: 'addressCountry', title: 'Χώρα διεύθυνσης '},
  {refValue: 'addressCountryCode', title: 'Κωδικός χώρας διεύθυνσης'},
  {refValue: 'phone1', title: 'Τηλέφωνο 1'},
  {refValue: 'phone2', title: 'Τηλέφωνο 2'},
  {refValue: 'deathIndication', title: 'Ένδειξη θανάτου (Θ = έχει αναγγελθεί θάνατος Λ = έχει αναγγελθεί θάνατος με Ληξιαρχική πράξη)'},
  {refValue: 'deathDate', title: 'Ημερομηνία Θανάτου'},
];

export const amkaByInfoRefs = [
  {refValue: 'amkaCurrent', title: 'ΑΜΚΑ ισχύων'},
  {refValue: 'lastDataLogDate', title: 'Ημερομηνία πιο πρόσφατης καταχώρησης των στοιχείων'},
  {refValue: 'adt', title: 'Αριθμός ταυτότητας'},
  {refValue: 'nationalityCountry', title: 'Χώρα υπηκοότητας'},
  {refValue: 'nationalityCountryCode', title: 'Κωδικός χώρας υπηκοότητας'},
  {refValue: 'afm', title: 'ΑΦΜ'},
  {refValue: 'birthSurnameEl', title: 'Επώνυμο κατά τη γέννηση (Ελληνικά)'},
  {refValue: 'idSurnameEl', title: 'Επώνυμο τρέχον (ταυτότητας) (Ελληνικά)'},
  {refValue: 'firstNameEl', title: 'Όνομα (Ελληνικά)'},
  {refValue: 'fatherNameEl', title: 'Πατρώνυμο (Ελληνικά)'},
  {refValue: 'motherNameEl', title: 'Μητρώνυμο (Ελληνικά)'},
  {refValue: 'birthSurnameEn', title: 'Επώνυμο κατά τη γέννηση (Λατινικά)'},
  {refValue: 'idSurnameEn', title: 'Επώνυμο τρέχον (ταυτότητας) (Λατινικά)'},
  {refValue: 'firstNameEn', title: 'Όνομα (Λατινικά)'},
  {refValue: 'fatherNameEn', title: 'Πατρώνυμο (Λατινικά)'},
  {refValue: 'motherNameEn', title: 'Μητρώνυμο (Λατινικά)'},
  {refValue: 'birthDate', title: 'Ημερομηνία γέννησης'},
  {refValue: 'fictitiousBirthDateIndication', title: 'Ένδειξη πλασματικής ημερομηνίας γέννησης, Π = πλασματική'},
  {refValue: 'deathIndication', title: 'Ένδειξη θανάτου (Θ = έχει αναγγελθεί θάνατος, Λ = έχει αναγγελθεί θάνατος με Ληξιαρχική πράξη)'},
  {refValue: 'deathDate', title: 'Ημερομηνία Θανάτου'},
];

export const paidParavolaRefs = [
  {refValue: 'foreasID', title: 'Κωδικός Φορέα'},
  {refValue: 'foreasDescription', title: 'Περιγραφή Φορέα'},
  {refValue: 'categoryId', title: 'Κωδικός κατηγορίας παραβόλου'},
  {refValue: 'categoryDescription', title: 'Περιγραφή κατηγορίας παραβόλου'},
  {refValue: 'typeId', title: 'Κωδικός τύπου παραβόλου'},
  {refValue: 'typeDescription', title: 'Περιγραφή τύπου παραβόλου'},
  {refValue: 'paravCode', title: 'Κωδικός πληρωμής παραβόλου'},
  {refValue: 'currentPrice', title: 'Ποσό πληρωμής παραβόλου'},
  {refValue: 'afm', title: 'ΑΦΜ'},
  {refValue: 'actualPaidDate', title: 'Ημερομηνία πληρωμής'},
  {refValue: 'actualPaidDateStr', title: 'Ημερομηνία πληρωμής'},
];

export const usedParavolaRefs = [
  {refValue: 'foreasID', title: 'Κωδικός Φορέα'},
  {refValue: 'foreasDescription', title: 'Περιγραφή Φορέα'},
  {refValue: 'categoryId', title: 'Κωδικός κατηγορίας παραβόλου'},
  {refValue: 'categoryDescription', title: 'Περιγραφή κατηγορίας παραβόλου'},
  {refValue: 'typeId', title: 'Κωδικός τύπου παραβόλου'},
  {refValue: 'typeDescription', title: 'Περιγραφή τύπου παραβόλου'},
  {refValue: 'paravCode', title: 'Κωδικός πληρωμής παραβόλου'},
  {refValue: 'currentPrice', title: 'Ποσό πληρωμής παραβόλου'},
  {refValue: 'afm', title: 'ΑΦΜ'},
  {refValue: 'createDate', title: 'Ημερομηνία πληρωμής'},
  {refValue: 'createDateStr', title: 'Ημερομηνία πληρωμής '},
  {refValue: 'serviceName', title: 'Υπηρεσία δέσμευσης'},
  {refValue: 'userName', title: 'Χρήστης δέσμευσης'},
];

export const refundParavolaRefs = [
  {refValue: 'foreasID', title: 'Κωδικός Φορέα'},
  {refValue: 'foreasDescription', title: 'Περιγραφή Φορέα'},
  {refValue: 'categoryId', title: 'Κωδικός κατηγορίας παραβόλου'},
  {refValue: 'categoryDescription', title: 'Περιγραφή κατηγορίας παραβόλο'},
  {refValue: 'typeId', title: 'Κωδικός τύπου παραβόλου'},
  {refValue: 'typeDescription', title: 'Περιγραφή τύπου παραβόλου'},
  {refValue: 'paravCode', title: 'Κωδικός πληρωμής παραβόλου'},
  {refValue: 'currentPrice', title: 'Ποσό πληρωμής παραβόλου'},
  {refValue: 'refundPrice', title: 'Ποσό επιστροφής'},
  {refValue: 'afm', title: 'ΑΦΜ'},
  {refValue: 'createDate', title: 'Ημερομηνία πληρωμής'},
  {refValue: 'createDateStr', title: 'Ημερομηνία πληρωμής'},
  {refValue: 'refundCompleteDate', title: 'Ημερομηνία επιστροφής'},
  {refValue: 'refundCompleteDateStr', title: 'Ημερομηνία επιστροφής σε Αλφαριθμητική μορφή '},
  {refValue: 'serviceName', title: 'Υπηρεσία επιστροφής'},
  {refValue: 'userName', title: 'Χρήστης επιστροφής'},
  {refValue: 'reason', title: 'Αιτιολογία'},
];

export const userDetailsAFMRefs = [
  { refValue: 'firstName', title: 'Όνομα φορολογούμενου' },
  { refValue: 'lastName', title: 'Επώνυμο φορολογούμενου ή Επωνυμία επιχείρηση' },
  { refValue: 'fatherName', title: 'Πατρώνυμο φορολογούμενου' }
];

export const paravoloTypeRefs = [
  { refValue: 'description', title: 'Κατάσταση τύπου παραβόλου' },
  { refValue: 'price', title: 'Ποσό παραβόλου' }
];

export const paravoloStatusRefs = [
  {refValue: 'statusId', title: 'Μοναδικός κωδικός αριθμός περιγραφής κατάστασης'},
  {refValue: 'statusName', title: 'Περιγραφή'},
  {refValue: 'statusId', title: 'Μοναδικός κωδικός αριθμός περιγραφής επιστροφής'},
  {refValue: 'statusName', title: 'Περιγραφή'},
];

export const createParavoloRefs = [
  {refValue: 'paravoloCode', title: ' Κωδικός παραβόλου'},
  {refValue: 'paravoloRfCode', title: ' RF κωδικός πληρωμής'},
  {refValue: 'afm', title: ' ΑΦΜ'},
  {refValue: 'firstName', title: ' Όνομα'},
  {refValue: 'lastName', title: ' Επώνυμο / Επωνυμία'},
  {refValue: 'fatherName', title: ' Πατρώνυμο'},
  {refValue: 'motherName', title: ' Μητρώνημο'},
  {refValue: 'iban', title: ' Κωδικός IBAN'},
  {refValue: 'emailAddress', title: ' Διεύθυνση Email'},
  {refValue: 'mobilePhone', title: ' Κινητό τηλέφωνο'},
  {refValue: 'birthDate', title: ' Ημερομηνία γέννησης'},
  {refValue: 'additionalInfo', title: ' Πρόσθετα στοιχεία'},
  {refValue: 'paravoloForeas', title: ' Περιγραφή του φορέα για τον οποίο έγινε η δημιουργία'},
  {refValue: 'paravoloCategory', title: ' Περιγραφή της κατηγορίας για την οποία έγινε η δημιουργία'},
  {refValue: 'paravoloType', title: ' Περιγραφή του τύπου για την οποία έγινε η δημιουργία'},
  {refValue: 'paravoloAmount', title: ' Ποσό (κόστος) του παραβόλου'},
  {refValue: 'paymentExpirationDate', title: ' Καταληκτική ημερομηνία πληρωμής'},
  {refValue: 'statusId', title: 'Μοναδικός κωδικός αριθμός περιγραφής κατάστασης'},
  {refValue: 'statusName', title: 'Περιγραφή κατάστασης'},
];
export const createParavoloShortRefs = [
  {refValue: 'paravoloCode', title: 'Κωδικός παραβόλου'},
  {refValue: 'paravoloRfCode', title: 'RF κωδικός πληρωμής'},
  {refValue: 'afm', title: 'ΑΦΜ'},
  {refValue: 'paravoloForeas', title: 'Περιγραφή του φορέα για τον οποίο έγινε η δημιουργία'},
  {refValue: 'paravoloCategory', title: 'Περιγραφή της κατηγορίας για την οποία έγινε η δημιουργία'},
  {refValue: 'paravoloType', title: 'Περιγραφή του τύπου για την οποία έγινε η δημιουργία'},
  {refValue: 'paravoloAmount', title: 'Ποσό (κόστος) του παραβόλου'},
  {refValue: 'paymentExpirationDate', title: 'Καταληκτική ημερομηνία πληρωμής'},
  {refValue: 'statusId', title: 'Μοναδικός κωδικός αριθμός περιγραφής κατάστασης'},
  {refValue: 'statusName', title: 'Περιγραφή κατάστασης'},
];

export const gemiAFMRefs = [
  {refValue: 'gemiNumber', title: 'Αριθμός ΓΕΜΗ'},
  {refValue: 'responsibleOrg', title: 'Υπεύθυνο Επιμελητήριο'},
  {refValue: 'isBranch', title: 'Υποκατάστημα'},
  {refValue: 'legalType', title: 'Νομική Μορφή Επιχείρησης'},
];

export const gemiBasicInfoRefs = [
  {refValue: 'arGemi', title: ' Αριθμός Μητρώου ΓΕΜΗ'},
  {refValue: 'afm', title: ' Αριθμός Φορολογικού Μητρώου'},
  {refValue: 'legalTypeId', title: ' Κωδικός Νομικής Μορφής'},
  {refValue: 'memberStatusId', title: ' Κωδικός Κατάστασης Επιχείρησης'},
  {refValue: 'doyId', title: ' Κωδικός Δ.Ο.Υ.'},
  {refValue: 'businessName', title: ' Επωνυμία Επιχείρησης'},
  {refValue: 'businessTitle', title: ' Διακριτικός Τίτλος Επιχείρησης'},
  {refValue: 'companygoal', title: ' Σκοπός'},
  {refValue: 'orgId', title: ' Κωδικός Αρμόδιας Υπηρεσίας ΓΕΜΗ'},
  {refValue: 'regionId', title: ' Κωδικός Νομού'},
  {refValue: 'municipalityId', title: ' Κωδικός Δήμου'},
  {refValue: 'street', title: ' Οδός'},
  {refValue: 'number', title: ' Αριθμός'},
  {refValue: 'tk', title: ' Ταχυδρομικός Κώδικας'},
  {refValue: 'city', title: ' Πόλη'},
  {refValue: 'fax', title: ' ΦΑΞ'},
  {refValue: 'mobile', title: ' Αριθμός κινητού τηλεφώνου'},
];

export const gemiBasicInfoV3Refs = [
  {refValue: 'arGemi', title: 'Αριθμός ΓΕΜΗ Επιχείρησης'},
  {refValue: 'afm', title: 'Α.Φ.Μ. Επιχείρησης'},
  {refValue: 'legalTypeId', title: 'Κωδικός Νομικής Μορφής Επιχείρησης'},
  {refValue: 'legalTypeDescr', title: 'Περιγραφή Νομικής Μορφής Επιχείρησης'},
  {refValue: 'memberStatusId', title: 'Κωδικός Κατάστασης Επιχείρησης'},
  {refValue: 'memberStatusDescr', title: 'Περιγραφή Κατάστασης Επιχείρησης'},
  {refValue: 'doyId', title: 'Κωδικός ΔΟΥ Επιχείρησης'},
  {refValue: 'doyDescr', title: 'Περιγραφή ΔΟΥ Επιχείρησης'},
  {refValue: 'businessName', title: 'Επωνυμία Επιχείρησης'},
  {refValue: 'businessTitles', title: 'Διακριτικοί Τίτλοι Επιχείρησης'},
  {refValue: 'companyGoal', title: 'Σκοπός Επιχείρησης'},
  {refValue: 'orgId', title: 'Κωδικός Αρμόδιας Υπ.ΓΕΜΗ'},
  {refValue: 'orgDescr', title: 'Αρμόδια Υπ.ΓΕΜΗ'},
  {refValue: 'prefectureId', title: 'Κωδικός Νομού'},
  {refValue: 'prefectureDescr', title: 'Νομός'},
  {refValue: 'municipalityId', title: 'Κωδικός Δήμου'},
  {refValue: 'municipalityDescr', title: 'Δήμος'},
  {refValue: 'street', title: 'Οδός'},
  {refValue: 'streetNumber', title: 'Αριθμός Οδού'},
  {refValue: 'tk', title: 'Ταχυδρομικός Κώδικας'},
  {refValue: 'city', title: 'Πόλη'},
  {refValue: 'region', title: 'Περιοχή'},
  {refValue: 'phone', title: 'Τηλέφωνο Επιχείρησης'},
  {refValue: 'fax', title: 'Φαξ Επιχείρησης'},
  {refValue: 'mobile', title: 'Κινητό Επιχείρησης'},
  {refValue: 'englishName', title: 'Αγγλική Επωνυμία Επιχείρησης'},
  {refValue: 'dateCreated', title: 'Ημερομηνία Σύστασης Επιχείρησης'},
  {refValue: 'arMae', title: 'Αριθμός ΜΑΕ'},
  {refValue: 'email', title: 'Διεύθυνση Ηλεκτρονικής Αλληλογραφίας'},
  {refValue: 'website', title: 'Ιστοσελίδα Επιχείρησης'},
  {refValue: 'eshop', title: 'Εμπορική Ιστοσελίδα'},
  {refValue: 'dateLastChange', title: 'Ημερομηνία τελευταίας αλλαγής'},
  {refValue: 'departmentId', title: 'Κωδικός Τμήματος'},
  {refValue: 'departmentDescr', title: 'Περιγραφή Τμήματος'},
  {refValue: 'duration', title: 'Διάρκεια'},
  {refValue: 'expirationDate', title: 'Ημερομηνία Λήξης'},
  {refValue: 'professionStarted', title: 'Ημερομηνία Έναρξης Επιτηδεύματος'},
  {refValue: 'dateRegistered', title: 'Ημερομηνία Εγγραφής στο ΓΕΜΗ'},
];

export const afeValidationRefs = [
  {refValue: 'rvAfeFound', title: 'Ένδειξη εύρεσης με τιμές 0: Δεν βρέθηκε, 1: Βρέθηκε'},
  {refValue: 'rvAfeValMonths', title: 'Μήνες ισχύος του αποδεικτικού φορ. ενημερότητας'},
  {refValue: 'rvAfeIssueDate', title: 'Ημερομηνία και ώρα έκδοσης'},
  {refValue: 'rvAfeEndDate', title: 'Ημερομηνία λήξης ισχύος'},
  {refValue: 'rvAfeIssuedByAfm', title: 'ΑΦΜ εκδότη ή κενό όταν ο εκδότης είναι ΔΟΥ'},
  {refValue: 'rvAfeIssuedByDescr', title: 'Περιγραφή του αιτούντα έκδοσης του αποδεικτικού φορολογικής ενημερότητας (Φορέας)'},
  {refValue: 'rvAfeIssuedByDescr2', title: 'Περιγραφή της Υπηρεσίας που αιτείται την έκδοση του αποδεικτικού φορολογικής ενημερότητας'},
  {refValue: 'rvAfeIssuedByDescr3', title: 'Ταχυδρομική διεύθυνση της Υπηρεσίας που αιτείται την έκδοση του αποδεικτικού φορολογικής ενημερότητας'},
  {refValue: 'rvAfeReason', title: 'Κωδικός λόγου έκδοσης'},
  {refValue: 'rvAfeReasonText', title: 'Περιγραφή του λόγου έκδοσης'},
  {refValue: 'rvAfiReasManIss', title: 'Αιτιολόγηση χορήγησης'},
  {refValue: 'rvAfiExoOrganization', title: 'Φορέας Κατάθεσης'},
  {refValue: 'rvAfiStoixeiaPaytitlePry', title: 'Στοιχεία Ακινήτου ή Στοιχεία Τίτλου Πληρωμής'},
  {refValue: 'rvAfiAtak', title: 'ΑΤΑΚ '},
  {refValue: 'rvAfiHoldAmount', title: 'Εκ του λαβείν ποσό'},
  {refValue: 'rvAfiHoldPcnt', title: 'Ποσοστό'},
  {refValue: 'rvAfiHoldAmntFlag', title: 'Ένδειξη Ολο το ποσό'},
  {refValue: 'rvAfiExpirationDate', title: 'Ημερομηνία λήξης'},
  {refValue: 'rvAfiNotHoldingReason', title: 'Λόγος μη διενέργειας παρακράτησης'},
  {refValue: 'rvAfiGeeNoteAa', title: 'ΑΑ εγγυητικής'},
  {refValue: 'rvAfiGeeNoteDate', title: 'Ημερομηνία εγγυητικής'},
  {refValue: 'rvAfiGeeNoteBank', title: 'Πιστ. ίδρυμα'},
  {refValue: 'rvAfiSumCrfAmnt', title: 'Συνολικό ποσό επιμεριστικού φόρου'},
  {refValue: 'rvAfiTop', title: 'ΤΟΠ (Ταυτότητα Οφειλής Παρακράτησης)'}
];
export const afeIssueRefs = [
  {refValue: 'rvAfeAfm', title: ' Α.Φ.Μ. φορολογούμενου που αφορά το ΑΦΕ'},
  {refValue: 'rvAfeAa', title: ' Αριθμός Συστήματος (Αρ. Πρωτοκόλλου) για το ΑΦΕ'},
  {refValue: 'rvAfeDoy', title: ' Κωδικός Δ.Ο.Υ. (εφόσον ο εκδότης είναι Δ.Ο.Υ.)'},
  {refValue: 'rvAfeDoyDescr', title: ' Περιγραφή Δ.Ο.Υ.'},
  {refValue: 'rvAfeIssueDate', title: ' Ημερομηνία Έκδοσης ΑΦΕ'},
  {refValue: 'rvAfeEndDate', title: ' Ημερομηνία Λήξης Ισχύος ΑΦΕ'},
  {refValue: 'rvAfeEnhmeros', title: ' 0: μη ενήμερος, 1 : ενήμερος για 1 μήνα, 2: ενήμερος για 2 μήνες'},
  {refValue: 'rvAfeResult', title: ' Αποτέλεσμα'},
  {refValue: 'rvAfeResultText', title: ' Περιγραφή του αποτελέσματος'},
  {refValue: 'rvAfeText', title: ' Στοιχεία του τίτλου πληρωμής'},
  {refValue: 'rvAfeForeas', title: ' Στοιχεία του φορέα που θα πληρώσει'},
  {refValue: 'rvAfeReason', title: ' Κωδικός λόγου έκδοσης'},
  {refValue: 'rvAfeReasonText', title: ' Περιγραφή του λόγου έκδοσης'},
  {refValue: 'rvAfeSurname', title: ' Επώνυμο Φορολογουμένου'},
  {refValue: 'rvAfeSecondSurname', title: ' Δεύτερο Επώνυμο Φορολογουμένου(αν υπάρχει)'},
  {refValue: 'rvAfeFirstName', title: ' ‘Όνομα Φορολογουμένου'},
  {refValue: 'rvAfeFirstNameSnd', title: ' Δεύτερο ‘Όνομα Φορολογουμένου (αν υπάρχει)'},
  {refValue: 'rvAfeFathersFirstName', title: ' Πατρώνυμο Φορολογουμένου'},
  {refValue: 'rvAfeFathersSurname', title: ' Επώνυμο Πατέρα Φορολογουμένου'},
  {refValue: 'rvAfeCardNo', title: ' Αριθμός ταυτότητας'},
  {refValue: 'rvAppelation', title: ' Επωνυμία'},
  {refValue: 'rvAfeINiFlag', title: ' Ένδειξη Φυσικού Προσώπου'},
  {refValue: 'rvAfePostalAddress', title: ' Οδός Αλληλογραφίας'},
  {refValue: 'rvAfePostalAddressNo', title: ' Αριθμός Αλληλογραφίας'},
  {refValue: 'rvAfePostalZipCode', title: ' ΤΚ Αλληλογραφίας'},
  {refValue: 'rvAfePostalParDescr', title: ' Περιοχή Αλληλογραφίας'},
  {refValue: 'rvAfeResidenceAddress', title: ' Οδός Κατοικίας'},
  {refValue: 'rvAfeResidenceAddressNo', title: ' Αριθμός Κατοικίας'},
  {refValue: 'rvAfeResidenceZipCode', title: ' ΤΚ Κατοικίας'},
  {refValue: 'rvAfeResidenceParDescr', title: ' Περιοχή Κατοικίας'},
];

// Collapsible Tables Headers
export const infoByNameheaderTitles = [
  {title: 'ΑΦΜ', refValue: 'afm'}, 
  {title: 'Επώνυμο', refValue: 'surname'},
  {title: 'Όνομα', refValue: 'firstName'},
  {title: 'Πατρώνυμο', refValue: 'fathersFirstName'}
];

export const infoByNamesubHeaderTitles = [
  {title: 'Επώνυμο 2ο', refValue: 'secondSurname'},
  {title: 'Όνομα Μητέρας', refValue: 'mothersFirstName'},
  {title: 'Ημερομηνία Γέννησης', refValue: 'birthDate'},
  {title: 'Ημερομηνία Θανάτου', refValue: 'deathDate'},
  {title: 'Δ.Ο.Υ', refValue: 'doy'},
  {title: 'Περιγραφή Δ.Ο.Υ', refValue: 'doyDescr'},
  {title: 'Ταυτότητα', refValue: 'cardNo'},
  {title: 'Περιγραφή Αρχής Έκδοσης Ταυτότητας', refValue: 'cardKindDescr'},
  {title: 'Ένδειξη Επιτηδευματία', refValue: 'firmFlagDescr'},
  {title: 'Οδός Κατοικίας', refValue: 'residenceAddress'},
  {title: 'Αριθμός Οδού Κατοικίας', refValue: 'residenceNo'},
  {title: 'Ταχυδρομικός Κώδικας Κατοικίας', refValue: 'parResidence'},
  {title: 'Περιοχή Κατοικίας', refValue: 'parResidenceDescr'},
  {title: 'Οδός Επιχείρησης', refValue: 'firmAddress'},
  {title: 'Αριθμός Οδού Διεύθυνσης Επιχείρησης', refValue: 'firmNo'},
  {title: 'Ταχυδρομικός Κώδικας Επιχείρησης', refValue: 'parBusiness'},
  {title: 'Περιοχή Επιχείρησης', refValue: 'parBusinessDescr'},
];

export const GemiBoardHeaderTitles = [
  {refValue: 'relationDescr', title: 'Ιδιότητα'},
  {title: 'ΑΦΜ', refValue: 'afm'}, 
  {title: 'Επώνυμο', refValue: 'lastname'},
  {title: 'Όνομα', refValue: 'firstname'},
];

export const GemiBoardSubHeaderTitles = [
  {refValue: 'homeStreet', title: 'Οδός'},
  {refValue: 'homeNumber', title: 'Αριθμός Οδού'},
  {refValue: 'homeTK', title: 'Ταχυδρομικός Κώδικας'},
  {refValue: 'isRepresentativeAlone', title: 'Εκπροσώπηση Απο Κοινού'},
  {refValue: 'isRepresentativeInCommon', title: 'Εκπροσώπηση Μεμονομένα'},
  {refValue: 'nationality', title: 'Εθνικότητα'},
  {refValue: 'citizenship', title: 'Υπηκοότητα'},
  {refValue: 'homeRegion', title: 'Περιφέρεια'},
  {refValue: 'homeMunicipality', title: 'Δήμος'},
  {refValue: 'phone', title: 'Τηλέφωνο'},
  {refValue: 'email', title: 'Διεύθυνση ηλεκτρονικού ταχυδρομείου'},
];

export const GemiBoardV3FPHeaderTitles = [
  {refValue: 'relationDescr', title: 'Σχέση Φυσικού Προσώπου'},
  {refValue: 'afm', title: 'ΑΦΜ Φυσικού Προσώπου'},
  {refValue: 'lastname', title: 'Επώνυμο Φυσικού Προσώπου'},
  {refValue: 'firstname', title: 'Όνομα Φυσικού Προσώπου'},
];

export const GemiBoardV3FPSubHeaderTitles = [
  {refValue: 'percentage', title: 'Ποσοστό'},
  {refValue: 'citizenship', title: 'Ιθαγένεια Φυσικού Προσώπου'},
  {refValue: 'homePrefecture', title: 'Νομός Φυσικού Προσώπου'},
  {refValue: 'homePrefectureId', title: 'Κωδικός Νομού Φυσικού Προσώπου'},
  {refValue: 'homeMunicipality', title: 'Δήμος Φυσικού Προσώπου'},
  {refValue: 'homeMunicipalityId', title: 'Κωδικός Δήμου Φυσικού Προσώπου'},
  {refValue: 'homeCity', title: 'Πόλη Φυσικού Προσώπου'},
  {refValue: 'homeStreet', title: 'Οδός Φυσικού Προσώπου'},
  {refValue: 'homeNumber', title: 'Αριθμός Οδού Φυσικού Προσώπου'},
  {refValue: 'zipCode', title: 'ΤΚ Φυσικού Προσώπου'},
  {refValue: 'phone', title: 'Τηλέφωνο Φυσικού Προσώπου'},
  {refValue: 'isRepresentativeAlone', title: 'Ένδειξη εκπροσώπου μεμονωμένα'},
  {refValue: 'isRepresentativeInCommon', title: 'Ένδειξη εκπροσώπου από κοινού'},
  {refValue: 'relationId', title: 'Κωδικός Σχέσης Φυσικού Προσώπου'},
  {refValue: 'relationType', title: 'Είδος Σχέσης Φυσικού Προσώπου'},
  {refValue: 'codeFP', title: 'Κωδικός Φυσικού Προσώπου'},
  {refValue: 'fathersName', title: 'Πατρώνυμο Φυσικού Προσώπου'},
  {refValue: 'mothersName', title: 'Μητρώνυμο Φυσικού Προσώπου'},
  {refValue: 'activeMember', title: 'Ένδειξη ενεργής σχέσης Φυσικού Προσώπου'},
  {refValue: 'electionDate', title: 'Ημερομηνία Εκλογής Φυσικού Προσώπου'},
  {refValue: 'startDate', title: 'Ημερομηνία Έναρξης Φυσικού Προσώπου'},
  {refValue: 'endDate', title: 'Ημερομηνία Λήξης Φυσικού Προσώπου'},
  {refValue: 'birthDate', title: 'Ημερομηνία Γέννησης Φυσικού Προσώπου'},
  {refValue: 'identityNumber', title: 'Αριθμός Ταυτότητας Φυσικού Προσώπου'},
  {refValue: 'identityType', title: 'Τύπος Ταυτότητας Φυσικού Προσώπου'},
  {refValue: 'identityDate', title: 'Ημερομηνία Έκδοσης Ταυτότητας Φυσικού Προσώπου'},
  {refValue: 'identityOffice', title: 'Εκδούσα Αρχή'},
];
export const GemiBoardV3NPHeaderTitles = [
  {refValue: 'afm', title: 'ΑΦΜ Νομικού Προσώπου'},
  {refValue: 'arGemi', title: 'Αρ.ΓΕΜΗ Νομικού Προσώπου'},
  {refValue: 'businessName', title: 'Επωνυμία Νομικού Προσώπου'},
  {refValue: 'legalTypeDescr', title: 'Νομική Μορφή Νομικού Προσώπου'},
  {refValue: 'relationType', title: 'Είδος Σχέσης Νομικού Προσώπου'},
];

export const GemiBoardV3NPSubHeaderTitles = [
  {refValue: 'codeNP', title: 'Κωδικός Νομικού Προσώπου'},
  {refValue: 'legalTypeId', title: 'Κωδικός Νομικής Μορφής Νομικού Προσώπου'},
  {refValue: 'electionDate', title: 'Ημερομηνία Εκλογής'},
  {refValue: 'relationDescr', title: 'Σχέση Νομικού Προσώπου'},
  {refValue: 'relationId', title: 'Κωδικός Σχέσης Νομικού Προσώπου'},
  {refValue: 'activeMember', title: 'Ένδειξη ενεργής σχέσης Νομικού Προσώπου'},
  {refValue: 'startDate', title: 'Ημερομηνία Έναρξης Σχέσης'},
  {refValue: 'endDate', title: 'Ημερομηνία Λήξης Σχέσης Νομικού Προσώπου'},
  {refValue: 'isRepresentativeAlone', title: 'Ένδειξη εκπροσώπου μεμονωμένα'},
  {refValue: 'isRepresentativeInCommon', title: 'Ένδειξη εκπροσώπου από κοινού'},
  {refValue: 'percentage', title: 'Ποσοστό'},
  {refValue: 'street', title: 'Οδός Νομικού Προσώπου'},
  {refValue: 'streetNumber', title: 'Αριθμός Οδού Νομικού Προσώπου'},
  {refValue: 'zipCode', title: 'ΤΚ Νομικού Προσώπου'},
  {refValue: 'city', title: 'Πόλη Νομικού Προσώπου'},
  {refValue: 'prefectureId', title: 'Κωδικός Νομού Νομικού Προσώπου'},
  {refValue: 'prefectureDescr', title: 'Νομός Νομικού Προσώπου'},
  {refValue: 'phone', title: 'Τηλέφωνο Νομικού Προσώπου'},
];
export const aadeKadFirmHeaderTitles = [
  {title: 'Ημερομηνία έναρξης της επιχείρησης', refValue: 'firmRegistDate'}, 
  {title: 'Περιγραφή ΚΑΔ', refValue: 'firmDescr'},
];

export const aadeKadFirmSubHeaderTitles = [
  {refValue: 'firmActivity', title: 'Δραστηριότητα ΚΑΔ'},
  {refValue: 'firmActStartDate', title: 'Ημερομηνία έναρξης'},
  {refValue: 'firmActStopDate', title: 'Ημερομηνία διακοπής'},
  {refValue: 'firmActKind', title: 'Είδος δραστηριότητας (1= Κύρια, 2= Δευτερεύουσα, 3= Λοιπή, 4=Βοηθητική)'},
  {refValue: 'firmActDesc', title: 'Περιγραφή δραστηριότητας επιχείρησης (κύρια)'},
  {refValue: 'firmStopDate', title: 'Ημερομηνία διακοπής επιχείρησης'},
];
export const aadeKadBranchHeaderTitles = [
  {title: 'Ημερομηνία έναρξης επιχείρησης', refValue: 'bacRegistDate'}, 
  {title: 'Περιγραφή ΚΑΔ', refValue: 'bacActDesc'}
];
export const aadeKadBranchSubHeaderTitles = [
  {refValue: 'bacUnitNumber', title: 'Νούμερο υποκαταστήματος'},
  {refValue: 'brnTitle', title: 'Τίτλος εγκατάστασης'},
  {refValue: 'bacActivity', title: 'Δραστηριότητα ΚΑΔ υποκαταστήματος'},
  {refValue: 'bacActKind', title: 'Είδος δραστηριότητας (1= Κύρια, 2= Δευτερεύουσα, 3= Λοιπή, 4= Βοηθητική)'},
  {refValue: 'firmActDesc', title: 'Περιγραφή δραστηριότητας επιχείρησης (κύρια)'},
  {refValue: 'bacStartDate', title: 'Ημερομηνία έναρξης δραστηριότητας '},
  {refValue: 'bacStopDate', title: 'Ημερομηνία διακοπής δραστηριότητας '},
  {refValue: 'brnUnitAddress', title: 'Διεύθυνση - Οδός υποκαταστήματος'},
  {refValue: 'brnUnitAddressNo', title: 'Διεύθυνση - Αριθμός υποκαταστήματος'},
  {refValue: 'brnParDesc', title: 'Διεύθυνση - Πόλη υποκαταστήματος'},
  {refValue: 'brnParBusiness', title: 'Διεύθυνση – Ταχυδρομικός κώδικας'},
  {refValue: 'brnStartDate', title: 'Ημερομηνία έναρξης υποκαταστήματος'},
  {refValue: 'brnStopDate', title: 'Ημερομηνία λήξης υποκαταστήματος'},
];

export const manageInteroperabilitiesHeaderTitles = [
  { title: 'id Διαλειτουργικοτητας', refValue: 'interoperability_id' },
  { title: 'Χρήστης', refValue: 'audit_user_id' },
  { title: 'Διαλειτουργικότητα', refValue: 'interoperability' },
  { title: 'Ημερομηνία Αναζήτησης', refValue: 'audit_transaction_date' },
  { title: 'Τιμές Αναζήτησης', refValue: 'values' },
];

export const manageInteroperabilitiesSubHeaderTitles = [
  { title: 'Χρήστης', refValue: 'audit_user_id' },
  { title: 'Διαλειτουργικότητα', refValue: 'interoparability' },
  { title: 'Ημερομηνία Αναζήτησης', refValue: 'audit_transaction_date' },
];

export const AADEAFMSubHeaderTitles = [
  { refValue: 'error', title: ' Σφάλμα ' },
  { refValue: 'afm', title: ' Αριθμός Φορολογικού Μητρώου Α.Φ.Μ. ' },
  { refValue: 'doyDescr', title: ' Περιγραφή Δ.Ο.Υ' },
  { refValue: 'onomasia', title: ' Επωνυμία ή Επώνυμο, Β’ Επώνυμο, Όνομα, Πατρώνυμο ' },
  { refValue: 'birthDate', title: ' Ημερομηνία Γέννησης' },
];

export const AADENAMESubHeaderTitles = [
  { refValue: 'error', title: ' Σφάλμα ' },
  {title: 'ΑΦΜ', refValue: 'afm'}
];

export const AADEADTSubHeaderTitles = [
  { refValue: 'error', title: ' Σφάλμα ' },
  {refValue: 'doy', title: 'Δ.Ο.Υ'},
  {refValue: 'doyDescr', title: 'Περιγραφή Δ.Ο.Υ.'},
  {refValue: 'surname', title: 'Επώνυμο'},
  {refValue: 'firstName', title: 'Όνομα'},
  {refValue: 'cardNo', title: 'Αριθμός Δελτίου Ταυτότητας'},
  {refValue: 'cardKindDescr', title: 'Περιγραφή Είδους Ταυτότητας'},
  {refValue: 'cardAuthDescr', title: 'Περιγραφή Αρχής Έκδοσης Ταυτότητας'},
  {refValue: 'cardDate', title: 'Ημερομηνία Έκδοσης Ταυτότητας'},
  {refValue: 'afm', title: 'Aριθμός Φορολογικού Μητρώου Α.Φ.Μ'},
];

export const BANKCONFIRMATIONSubHeaderTitles = [
  { refValue: 'error', title: ' Σφάλμα ' },
  { title: 'Τράπεζα', refValue: 'bank' },
  { title: 'Επιτυχημένη ή όχι διασταύρωση (τιμές: 1 ή 0 αντίστοιχα)', refValue: 'confirmed' },
  { title: 'Ένδειξη ενεργού ή ανενεργού λογαριασμού σε ευρώ (τιμές: 1 ή 0 αντίστοιχα)', refValue: 'usageAllowed' },
];

export const HDIKAINFOSubHeaderTitles = [
  { refValue: 'error', title: ' Σφάλμα ' },
  {refValue: 'amkaCurrent', title: 'Ισχύων ΑΜΚΑ'},
  {refValue: 'adt', title: 'Αριθμός ταυτότητας'},
  {refValue: 'yearOfAdtPublished', title: 'Έτος έκδοσης ταυτότητας'},
  {refValue: 'nationalityCountry', title: 'Χώρα υπηκοότητας'},
  {refValue: 'afm', title: 'ΑΦΜ'},
  {refValue: 'idSurnameEl', title: 'Επώνυμο τρέχον (ταυτότητας) (Ελληνικά)'},
  {refValue: 'firstNameEl', title: 'Όνομα (Ελληνικά)'},
  {refValue: 'birthCountry', title: 'Χώρα γέννησης'},
  {refValue: 'phone1', title: 'Τηλέφωνο 1'}
];

export const HDIKAPAAYPASubHeaderTitles = [
  { refValue: 'error', title: ' Σφάλμα ' },
  {refValue: 'amkaCurrent', title: 'ΑΜΚΑ ισχύων'},
  {refValue: 'adt', title: 'Αριθμός ταυτότητας'},
  {refValue: 'nationalityCountry', title: 'Χώρα υπηκοότητας'},
  {refValue: 'afm', title: 'ΑΦΜ'},
  {refValue: 'firstNameEl', title: 'Όνομα (Ελληνικά)'},
  {refValue: 'idSurnameEn', title: 'Επώνυμο τρέχον (ταυτότητας) (Λατινικά)'},
];

export const HDIKAAMKASubHeaderTitles = [
  { refValue: 'error', title: ' Σφάλμα ' },
  {refValue: 'amkaCurrent', title: 'ΑΜΚΑ ισχύων'},
  {refValue: 'adt', title: 'Αριθμός ταυτότητας'},
  {refValue: 'nationalityCountry', title: 'Χώρα υπηκοότητας'},
  {refValue: 'afm', title: 'ΑΦΜ'},
  {refValue: 'idSurnameEl', title: 'Επώνυμο τρέχον (ταυτότητας) (Ελληνικά)'},
  {refValue: 'firstNameEl', title: 'Όνομα (Ελληνικά)'},
  {refValue: 'birthDate', title: 'Ημερομηνία γέννησης'},
];
export const AADEKADSubHeaderTitles = [
  { refValue: 'error', title: ' Σφάλμα ' },
  { title: 'Χρήστης', refValue: 'audit_user_id' },
  { title: 'Διαλειτουργικότητα', refValue: 'interoparability' },
  { title: 'Ημερομηνία Αναζήτησης', refValue: 'audit_transaction_date' },
];

// Static JSONS to map interopebility responses to Dictionary
export const adtTypes: {[key: string]: string | number} = {
  'Α': 'ΑΛΛΟ ΠΑΡΑΣΤΑΤΙΚΟ',
  'Δ': 'ΔΙΑΒΑΤΗΡΙΟ',
  'Λ': 'ΛΗΞΙΑΡΧΙΚΗ ΠΡΑΞΗ ΓΕΝΝΗΣΗΣ',
  'Μ': 'ΜΕΡΙΔΑ ΟΙΚΟΓΕΝΕΙΑΚΗ',
  'Ο': 'ΤΑΥΤΟΤΗΤΑ ΟΜΟΓΕΝΟΥΣ',
  'Σ': 'ΕΛΛΗΝΙΚΗ ΣΤΡΑΤΙΩΤΙΚΗ',
  'Τ': 'ΕΛΛΗΝΙΚΗ ΑΣΤΥΝΟΜΙΚΗ',
  '1': 'ΑΔ.ΔΙΑΜ.ΔΙΚΑΙΟΥΧ.ΔΙΕΘΝ.ΠΡΟΣΤΑΣ',
  '2': 'ΔΕΛΤ.ΑΙΤΟΥΝΤΟΣ ΔΙΕΘ.ΠΡΟΣΤΑΣΙΑΣ',
  '3': 'ΔΕΛΤ.ΑΙΤΗΣΑΝΤΟΣ ΑΣΥΛΟΥ',
  '4': 'ΒΙΝΙΕΤΑ',
  '5': 'ΒΕΒ. ΚΑΤ. ΑΙΤ. ΓΙΑ ΕΚ. ΑΔ. ΔΙ.',
  '6': 'ΔΕΛΤΙΟ ΔΙΑΜΟΝΗΣ',
  '7': 'ΔΕΛΤΙΟ ΜΟΝΙΜΗΣ ΔΙΑΜΟΝΗΣ',
  '8': 'ΕΙΔΙΚΗ ΒΕΒ/ΣΗ ΝΟΜΙΜΗΣ ΔΙΑΜΟΝΗΣ',
  '9': 'ΑΥΤΟΤΕΛΕΣ ΕΓΓΡΑΦΟ',
};

export const paaypaStatusTypes: {[key: string]: string | number} = {
  'default': 'Ενεργός ΑΜΚΑ',
  'ΑΑ': 'ΑΜΚΑ σε αναστολή',
  'Π': 'ενεργός ΠΑΑΥΠΑ',
  'ΠΑ': 'ΠΑΑΥΠΑ σε προσωρινή αναστολή',
  'ΠΚ': 'ΠΑΑΥΠΑ οριστικά καταργημένος',
  'ΠΡ': 'Προσωρινός ΑΜΚΑ *',
};
export const legalGemiTypes: {[key: string]: string | number} = {
  '0': 'Inadequate Info',
  '1': 'ΑΕ',
  '2': 'ΟΕ',
  '3': 'ΣυνΠΕ',
  '4': 'ΕΕ',
  '8': 'ΕΠΕ',
  '9': 'ΚΟΙΝΩΝΙΑ',
  '10': 'Ευρωπαϊκός Όμιλος Οικονομικού Σκοπού ',
  '11': 'Συνεταιρισμός ',
  '12': 'Ευρωπαϊκή Εταιρία (SE) ',
  '13': 'Ευρωπαϊκή Συνεταιριστική Εταιρία (SCE) ',
  '14': 'Κοινοπραξία ',
  '16': 'ΑΤΟΜΙΚΗ ',
  '17': 'ΕΝΩΣΗ ΠΡΟΣΩΠΩΝ ',
  '18': 'Αστική Εταιρία 784 Α.Κ. ',
  '19': 'ΙΚΕ ',
  '20': 'ΚΟΙ.Σ.Π.Ε ',
  '64': 'ΛΟΙΠΩΝ ΥΠΟΧΡΕΩΝ ',
  '65': 'Ενεργειακή Κοινότητα ',
  '66': 'Κοιν.Σ.Επ. ',
  '67': 'Συνεταιρισμός Εργαζομένων ',
  '68': 'ΕΕ κατά μετοχές ',
};
export const EpimelitiriaDictionary: {[key: string]: string | number} = {
  '25': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΗΛΕΙΑΣ',
  '26': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΗΜΑΘΙΑΣ',
  '27': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΗΡΑΚΛΕΙΟΥ',
  '28': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΘΕΣΠΡΩΤΙΑΣ',
  '2': ' ΒΙΟΤΕΧΝΙΚΟ ΕΠΙΜΕΛΗΤΗΡΙΟ  ΑΘΗΝΑΣ',
  '8': ' ΒΙΟΤΕΧΝΙΚΟ ΕΠΙΜΕΛΗΤΗΡΙΟ  ΠΕΙΡΑΙΩΣ',
  '7': ' ΕΜΠΟΡΙΚΟ & ΒΙΟΜΗΧΑΝΙΚΟ ΕΠΙΜΕΛΗΤΗΡΙΟ  ΠΕΙΡΑΙΩΣ',
  '3': ' ΕΠΑΓΓΕΛΜΑΤΙΚΟ ΕΠΙΜΕΛΗΤΗΡΙΟ  ΑΘΗΝΑΣ',
  '9': ' ΕΠΑΓΓΕΛΜΑΤΙΚΟ ΕΠΙΜΕΛΗΤΗΡΙΟ  ΠΕΙΡΑΙΩΣ',
  '5': ' ΒΙΟΤΕΧΝΙΚΟ ΕΠΙΜΕΛΗΤΗΡΙΟ  ΘΕΣΣΑΛΟΝΙΚΗΣ',
  '4': ' ΕΜΠΟΡΙΚΟ & ΒΙΟΜΗΧΑΝΙΚΟ ΕΠΙΜΕΛΗΤΗΡΙΟ  ΘΕΣ/ΝΙΚΗΣ',
  '1': ' ΕΜΠΟΡΙΚΟ & ΒΙΟΜΗΧΑΝΙΚΟ ΕΠΙΜΕΛΗΤΗΡΙΟ ΑΘΗΝΩΝ',
  '10': 'ΕΜΠΟΡΙΚΟ & ΒΙΟΜΗΧΑΝΙΚΟ ΕΠΙΜΕΛΗΤΗΡΙΟ  ΡΟΔΟΠΗΣ',
  '11': 'ΕΠΑΓΓΕΛΜΑΤΙΚΟ & ΒΙΟΤΕΧΝΙΚΟ ΕΠΙΜΕΛΗΤΗΡΙΟ  ΡΟΔΟΠΗΣ',
  '12': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΑΙΤΩΛ/ΝΑΝΙΑΣ',
  '13': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΑΡΓΟΛΙΔΑΣ',
  '14': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΑΡΚΑΔΙΑΣ',
  '15': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΑΡΤΑΣ',
  '16': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΑΧΑΙΑΣ',
  '17': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΒΟΙΩΤΙΑΣ',
  '18': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΓΡΕΒΕΝΩΝ',
  '19': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΔΡΑΜΑΣ',
  '20': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΔΩΔ/ΝΗΣΟΥ',
  '21': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΕΒΡΟΥ',
  '22': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΕΥΒΟΙΑΣ',
  '23': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΕΥΡΥΤΑΝΙΑΣ',
  '24': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΖΑΚΥΝΘΟΥ',
  '29': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΙΩΑΝΝΙΝΩΝ',
  '30': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΚΑΒΑΛΑΣ',
  '31': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΚΑΡΔΙΤΣΑΣ',
  '32': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΚΑΣΤΟΡΙΑΣ',
  '33': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΚΕΡΚΥΡΑΣ',
  '34': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΚΕΦΑΛΛΗΝΙΑΣ-ΙΘΑΚΗΣ',
  '35': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΚΙΛΚΙΣ',
  '36': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΚΟΖΑΝΗΣ',
  '37': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΚΟΡΙΝΘΙΑΣ',
  '38': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΚΥΚΛΑΔΩΝ',
  '39': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΛΑΚΩΝΙΑΣ',
  '40': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΛΑΡΙΣΑΣ',
  '41': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΛΑΣΙΘΙΟΥ',
  '42': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΛΕΣΒΟΥ                             ',
  '43': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΛΕΥΚΑΔΑΣ                           ',
  '44': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΜΑΓΝΗΣΙΑΣ',
  '45': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΜΕΣΣΗΝΙΑΣ',
  '46': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΞΑΝΘΗΣ',
  '47': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΠΕΛΛΑΣ',
  '48': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΠΙΕΡΙΑΣ',
  '49': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΠΡΕΒΕΖΑΣ',
  '50': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΡΕΘΥΜΝΗΣ',
  '52': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΣΕΡΡΩΝ',
  '58': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΧΑΝΙΩΝ',
  '59': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΧΙΟΥ',
  '51': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΣΑΜΟΥ',
  '53': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΤΡΙΚΑΛΩΝ',
  '54': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΦΘΙΩΤΙΔΑΣ',
  '55': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΦΛΩΡΙΝΑΣ',
  '56': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΦΩΚΙΔΑΣ',
  '57': 'ΕΠΙΜΕΛΗΤΗΡΙΟ ΧΑΛΚΙΔΙΚΗΣ',
  '6': ' ΕΠΑΓΓΕΛΜΑΤΙΚΟ ΕΠΙΜΕΛΗΤΗΡΙΟ  ΘΕΣΣΑΛΟΝΙΚΗΣ',
};
export const afeValidationOptions = [
  { key: 'ΔΟΥ', value: 1 },
  { key: 'INTERNET', value: 2 },
];
export const afeIssueOptions = [
  { key: 'Κάθε νόμιμη χρήση εκτός είσπραξης και εκτός μεταβίβασης ακινήτου', value: 2 },
  { key: 'Μεταβίβαση ακινήτου', value: 3 },
  { key: 'Είσπραξη χρημάτων από φορείς της κεντρικής διοίκησης', value: 4 },
  { key: 'Είσπραξη χρημάτων από φορείς του δημοσίου τομέα (πλην κεντρικής διοίκησης)', value: 5 },
];
export const afeIssuePDFOptions = [
  { key: 'ΝΑΙ', value: 'Y' },
  { key: 'ΟΧΙ', value: 'n' },
];